"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8579],{

/***/ 48292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.903 3.488a.867.867 0 0 1 1.194 0l4.43 4.266c.329.317.329.831 0 1.149a.867.867 0 0 1-1.194 0L13.5 5.212l-3.833 3.69a.867.867 0 0 1-1.193 0 .791.791 0 0 1 0-1.148l4.43-4.266Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3.25c.466 0 .844.364.844.813v11.375c0 .448-.378.812-.844.812-.466 0-.844-.364-.844-.813V4.063c0-.45.378-.813.844-.813Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.219 14.625c.466 0 .843.364.843.813v5.687h16.875v-5.688c0-.448.378-.812.844-.812.466 0 .844.364.844.813v5.687c0 .431-.178.844-.494 1.149a1.72 1.72 0 0 1-1.194.476H5.063a1.72 1.72 0 0 1-1.193-.476 1.595 1.595 0 0 1-.494-1.149v-5.688c0-.448.378-.812.844-.812Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgShare);

/***/ }),

/***/ 84953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

var SvgThunder = function SvgThunder(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    d: "M0 0h256v256H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m213.85 125.46-112 120a8 8 0 0 1-13.69-7l14.66-73.33-57.63-21.64a8 8 0 0 1-3-13l112-120a8 8 0 0 1 13.69 7l-14.7 73.41 57.63 21.61a8 8 0 0 1 3 12.95Z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgThunder);

/***/ }),

/***/ 3168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47.39 29.367C50.352 16.45 42.282 3.574 29.363.611 16.446-2.352 3.571 5.718.608 18.636c-2.963 12.918 5.107 25.793 18.025 28.756 12.918 2.963 25.793-5.106 28.756-18.025Z",
    fill: "#CBD5E1"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.999 33.86c5.155 0 9.334-5.79 9.334-12.93S29.154 8.001 24 8.001c-5.156 0-9.335 5.789-9.335 12.93 0 7.14 4.18 12.928 9.335 12.928Z",
    fill: "#F8FAFC"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.854 33.032c-7.816 0-14.8 1.875-19.448 4.818a23.987 23.987 0 0 0 39.095.13c-4.643-3.017-11.72-4.948-19.647-4.948Z",
    fill: "#F8FAFC"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M25.422 23.998h-2.846a3.565 3.565 0 0 0-3.565 3.565v8.112a3.565 3.565 0 0 0 3.565 3.565h2.846a3.565 3.565 0 0 0 3.564-3.565v-8.112a3.565 3.565 0 0 0-3.564-3.565ZM16.139 21.663c.278 2.075-.182 3.872-1.03 4.017-.849.145-1.76-1.42-2.039-3.494-.277-2.076.182-3.87 1.012-4.029.83-.159 1.775 1.435 2.057 3.506ZM31.87 21.663c-.282 2.075.181 3.872 1.026 4.017.845.145 1.76-1.42 2.042-3.494.282-2.076-.189-3.87-1.038-4.029-.848-.159-1.76 1.435-2.03 3.506Z",
    fill: "#F8FAFC"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.99 20.422c-.316-2.07-.63-4.14-.941-6.21-.115-.741-.226-1.542.048-2.253.274-.712 1.082-1.271 1.793-1.005-.285-1.441 1.308-2.505 2.694-2.964a16.123 16.123 0 0 1 7.26-.912 10.476 10.476 0 0 1 6.466 3.224c.537.569.952 1.24 1.22 1.975.477 1.42.174 2.965-.134 4.447l-.741 3.495a1.571 1.571 0 0 1-.3.74c-.29.323-.778.346-1.212.35l-13.889.029c-.867 0-2.005-.215-2.12-1.075",
    fill: "#F8FAFC"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgAvatar);

/***/ }),

/***/ 64874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

var SvgClockwatch = function SvgClockwatch(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.5 13.083v6.834h3.417m-16.23-.855a12.812 12.812 0 1 0 25.625 0 12.812 12.812 0 0 0-25.625 0v0ZM14.5 6.25V1.125 6.25ZM9.375 1.125h10.25-10.25Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClockwatch);

/***/ }),

/***/ 8390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VehicleDetail_VehicleDetailCarouselWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/common/BButton.tsx
var BButton = __webpack_require__(87114);
// EXTERNAL MODULE: ./src/components/common/Modal.tsx + 2 modules
var Modal = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/@phosphor-icons/react/dist/icons/ArrowsOutSimple.es.js
var ArrowsOutSimple_es = __webpack_require__(72325);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/common/BImage.tsx
var BImage = __webpack_require__(69327);
// EXTERNAL MODULE: ./src/components/common/ResponsiveCarousel.tsx
var ResponsiveCarousel = __webpack_require__(11455);
;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailCarousel.tsx





var VehicleDetailCarousel = function(param) {
    var images = param.images, vehicleName = param.vehicleName, onImageClick = param.onImageClick;
    var shownImages = images.length < 5 ? [
        images[0]
    ] : images.slice(0, 5);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveCarousel/* default */.Z, {
                    slidesPerView: 1,
                    pagination: {
                        type: "fraction"
                    },
                    children: images.map(function(image, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                            className: "h-[75vw] w-full",
                            onClick: onImageClick,
                            priority: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BImage/* default */.Z, {
                                src: image,
                                alt: "".concat(vehicleName, "-").concat(idx),
                                layout: "fill",
                                objectFit: "cover",
                                priority: idx === 0
                            })
                        }, image);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden md:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid h-[50vw] grid-cols-4 grid-rows-2 items-center gap-2 md:h-80 lg:h-[27rem] xl:h-[33rem] 2xl:h-[35rem]",
                    children: shownImages.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                        className: "relative col-span-4 row-span-2 h-full cursor-pointer",
                        onClick: onImageClick,
                        priority: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BImage/* default */.Z, {
                            src: images[0],
                            alt: "".concat(vehicleName, "-", 0),
                            layout: "fill",
                            objectFit: "cover",
                            priority: true
                        })
                    }) : shownImages.map(function(image, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                            className: classnames_default()("relative h-full cursor-pointer", {
                                "col-span-2 row-span-2": idx === 0,
                                "col-span-1 row-span-1": idx !== 0
                            }),
                            priority: "none",
                            onClick: onImageClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BImage/* default */.Z, {
                                src: image,
                                alt: "".concat(vehicleName, "-").concat(idx),
                                layout: "fill",
                                objectFit: "cover",
                                priority: idx < 5
                            })
                        }, "image-carousel-".concat(idx));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var VehicleDetail_VehicleDetailCarousel = (VehicleDetailCarousel);

;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailCarouselModalContent.tsx




var VehicleDetailCarouselModalContent = function(param) {
    var images = param.images, onImageClick = param.onImageClick, vehicleName = param.vehicleName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto grid max-w-xl grid-cols-2 gap-3",
        children: images.map(function(image, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                priority: "none",
                onClick: function() {
                    return onImageClick(idx);
                },
                className: classnames_default()("relative", {
                    "col-span-2 h-72 md:h-96": idx % 3 === 0,
                    "col-span-1 h-32 md:h-52": idx % 3 !== 0
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BImage/* default */.Z, {
                    src: image,
                    alt: "".concat(vehicleName, "-").concat(idx),
                    layout: "fill",
                    objectFit: "cover"
                })
            }, "modal-image-".concat(idx));
        })
    });
};
/* harmony default export */ var VehicleDetail_VehicleDetailCarouselModalContent = (VehicleDetailCarouselModalContent);

// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailGallery.tsx
var VehicleDetailGallery = __webpack_require__(62535);
;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailCarouselWrapper.tsx










var VehicleDetailCarouselWrapper = function(param) {
    var images = param.images, vehicleName = param.vehicleName, wrapperClass = param.wrapperClass;
    var t = (0,useTranslation/* default */.Z)().t;
    var ref = (0,react.useState)(false), showFullPageModal = ref[0], setShowFullPageModal = ref[1];
    var ref1 = (0,react.useState)(false), showFullPageGallery = ref1[0], setShowFullPageGallery = ref1[1];
    var ref2 = (0,react.useState)(0), initialIndex = ref2[0], setInitialIndex = ref2[1];
    var setShowFullPageGalleryWithInitialIndex = function(idx) {
        setInitialIndex(idx);
        setShowFullPageGallery(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()("vehicle-carousel relative", wrapperClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetail_VehicleDetailCarousel, {
                images: images,
                vehicleName: vehicleName,
                onImageClick: function() {
                    return setShowFullPageModal(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                variant: "info",
                priority: "outlined",
                className: "absolute bottom-6 right-6 hidden text-sm shadow-lg md:inline-block",
                onClick: function() {
                    return setShowFullPageModal(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsOutSimple_es/* default */.Z, {
                            className: "mr-2 h-4 w-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("vehicle:seeAllPhotos")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                modalClass: "w-full h-full",
                show: showFullPageModal,
                setShow: setShowFullPageModal,
                removeSlideToClose: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetail_VehicleDetailCarouselModalContent, {
                    images: images,
                    vehicleName: vehicleName,
                    onImageClick: setShowFullPageGalleryWithInitialIndex
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                setShow: setShowFullPageGallery,
                show: showFullPageGallery,
                modalClass: "w-full h-full bg-slate-900",
                modalBodyClass: "h-full",
                noLayout: true,
                fullScreen: true,
                removeSlideToClose: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailGallery/* default */.Z, {
                    images: images,
                    vehicleName: vehicleName,
                    setShow: setShowFullPageGallery,
                    initialIndex: initialIndex
                })
            })
        ]
    });
};
/* harmony default export */ var VehicleDetail_VehicleDetailCarouselWrapper = (VehicleDetailCarouselWrapper);


/***/ }),

/***/ 90825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_RatingStar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31399);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88082);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32466);
/* harmony import */ var services_DateService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49163);






var VehicleDetailCommentsItem = function(param) {
    var commentor = param.commentor, comment = param.comment, rating = param.rating, commentDate = param.commentDate, className = param.className, title = param.title, answer = param.answer;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("vehicle").t;
    var formattedDate = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return services_DateService__WEBPACK_IMPORTED_MODULE_5__/* .dateService.getReadableDate */ .o.getReadableDate(commentDate);
    }, [
        commentDate
    ]);
    var baseLayout = "flex-col-reverse items-start";
    var smLayout = "sm:flex-row sm:items-center";
    var mdLayout = "md:flex-col-reverse md:items-start";
    var lgLayout = "lg:flex-row lg:items-center";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex w-full gap-4", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex w-full justify-between", baseLayout, smLayout, mdLayout, lgLayout),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "inline-block",
                                    children: commentor
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_RatingStar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    rating: rating,
                                    hideCommentCount: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "inline-block text-sm text-slate-500",
                            children: formattedDate
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "inline-block font-medium",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "inline-block text-sm",
                        children: comment
                    })
                }),
                answer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-2 p-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between text-slate-500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("partnerAnswer")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-sm",
                                    children: services_DateService__WEBPACK_IMPORTED_MODULE_5__/* .dateService.getReadableDate */ .o.getReadableDate(services_DateService__WEBPACK_IMPORTED_MODULE_5__/* .dateService.formatServerDateToLocalDate */ .o.formatServerDateToLocalDate(answer.createdAt))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-medium",
                            children: answer.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-sm",
                            children: answer.content
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VehicleDetailCommentsItem);


/***/ }),

/***/ 50743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var hooks_useNumberFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58795);


var VehicleDetailCommentsSubAverageItem = function(param) {
    var average = param.average, label = param.label;
    var numberLocaleFormat = (0,hooks_useNumberFormat__WEBPACK_IMPORTED_MODULE_1__/* .useNumberFormat */ .h)().numberLocaleFormat;
    var ratingRange = 5 - 1;
    var averageWithRange = average - 1 > 4 ? 4 : average - 1;
    var totalLength = 160;
    var filledLength = Math.floor(totalLength / ratingRange * averageWithRange);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "text-sm",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "inline-block w-32",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "relative mr-2 inline-block h-2 rounded-full bg-slate-300",
                style: {
                    width: "".concat(totalLength, "px")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "absolute top-0 left-0 inline-block h-2 rounded-full bg-primary-500",
                    style: {
                        width: "".concat(filledLength, "px")
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: numberLocaleFormat(average)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VehicleDetailCommentsSubAverageItem);


/***/ }),

/***/ 24173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var components_common_Dropdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var components_common_DropdownClickableItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52588);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88082);
/* harmony import */ var _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37620);
/* harmony import */ var _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64742);
/* harmony import */ var _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34778);
/* harmony import */ var _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62982);
/* harmony import */ var _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77129);
/* harmony import */ var _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77000);





var VehicleDetailShareDropdown = function(param) {
    var show = param.show, onClose = param.onClose;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().t;
    var closedClick = function(cb) {
        return function() {
            cb();
            onClose === null || onClose === void 0 ? void 0 : onClose();
        };
    };
    var dropdownItems = [
        {
            icon: _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            text: t("vehicle:copyLink"),
            action: function() {
                navigator.clipboard.writeText(window.location.href);
            }
        },
        {
            icon: _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
            text: t("vehicle:email"),
            action: function() {
                window.open("mailto:?body=".concat(window.location.href), "_blank");
            }
        },
        {
            icon: _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            text: "Facebook",
            action: function() {
                window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(window.location.href), "_blank");
            }
        },
        {
            icon: _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            text: "Twitter",
            action: function() {
                window.open("https://twitter.com/messages/compose?text=".concat(window.location.href), "_blank");
            }
        },
        {
            icon: _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
            text: "LinkedIn",
            action: function() {
                window.open("https://www.linkedin.com/sharing/share-offsite/?url=".concat(window.location.href), "_blank");
            }
        },
        {
            icon: _phosphor_icons_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
            text: "WhatsApp",
            action: function() {
                window.open("whatsapp://send/?text=".concat(window.location.href), "_blank");
            }
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Dropdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        show: show,
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: dropdownItems.map(function(item) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_DropdownClickableItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    onClick: closedClick(item.action),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                className: "inline-block h-5 w-5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: item.text
                            })
                        ]
                    })
                }, "share-".concat(item.text));
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VehicleDetailShareDropdown);


/***/ }),

/***/ 61434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



var VehicleDetailTitledSection = function(param) {
    var children = param.children, title = param.title, className = param.className, _noHeading = param.noHeading, noHeading = _noHeading === void 0 ? false : _noHeading;
    var titleClasses = "mb-6 text-lg font-semibold block";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("vehicle-details-section", className),
        children: [
            noHeading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: titleClasses,
                children: title
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: titleClasses,
                children: title
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VehicleDetailTitledSection);


/***/ }),

/***/ 73351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88082);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var _TranslatedLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31468);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67320);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74021);







var BBreadcrumb = function(param) {
    var breadcrumbItems = param.breadcrumbItems, wrapperClasses = param.wrapperClasses;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().t;
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_6__/* .useLocale */ .b)().locale;
    var isCurrent = function(idx) {
        return idx === breadcrumbItems.length - 1;
    };
    var breadcrumbSchema = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return '{"@context": "https://schema.org","@type": "BreadcrumbList","itemListElement": ['.concat(breadcrumbItems.map(function(item, idx) {
            var label = item.isTranslatable ? t(item.label) : item.label;
            var nonQPLink = item.link.split("?")[0];
            var prefixedLink = "https://www.teknevia.com".concat(nonQPLink);
            return '{"@type": "ListItem","position":'.concat(+idx + 1, ',"name":"').concat(label, '","item":"').concat(prefixedLink, '"}');
        }).join(","), "]}");
    }, [
        breadcrumbItems,
        t,
        locale
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        "aria-label": "breadcrumbs",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                id: "breadcrumb-schema",
                type: "application/ld+json",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: breadcrumbSchema
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClasses, "flex flex-wrap items-center gap-2"),
                children: breadcrumbItems.map(function(item, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("breadcrumb-item text-xs md:text-sm", {
                            "text-primary-600 underline": !isCurrent(idx),
                            "text-black": isCurrent(idx)
                        }),
                        children: isCurrent(idx) ? item.isTranslatable ? t(item.label) : item.label : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TranslatedLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            href: item.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.isTranslatable ? t(item.label) : item.label
                            })
                        })
                    }, item.link);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BBreadcrumb);


/***/ }),

/***/ 47177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95592);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



var BSkeleton = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-5bb7646507d00c0c" + " " + (classnames__WEBPACK_IMPORTED_MODULE_2___default()("skeleton", className) || "")
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "5bb7646507d00c0c",
                children: '.skeleton.jsx-5bb7646507d00c0c{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;position:relative;overflow:hidden;background-color:var(--clr-gray-100);-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px}.skeleton.jsx-5bb7646507d00c0c::after{position:absolute;top:0;right:0;bottom:0;left:0;-webkit-transform:translateX(-100%);-moz-transform:translateX(-100%);-ms-transform:translateX(-100%);-o-transform:translateX(-100%);transform:translateX(-100%);background-image:-webkit-linear-gradient(left,rgba(255,255,255,0)0,rgba(255,255,255,.2)20%,rgba(255,255,255,.5)60%,rgba(255,255,255,0));background-image:-moz-linear-gradient(left,rgba(255,255,255,0)0,rgba(255,255,255,.2)20%,rgba(255,255,255,.5)60%,rgba(255,255,255,0));background-image:-o-linear-gradient(left,rgba(255,255,255,0)0,rgba(255,255,255,.2)20%,rgba(255,255,255,.5)60%,rgba(255,255,255,0));background-image:linear-gradient(90deg,rgba(255,255,255,0)0,rgba(255,255,255,.2)20%,rgba(255,255,255,.5)60%,rgba(255,255,255,0));-webkit-animation:shimmer 2s infinite;-moz-animation:shimmer 2s infinite;-o-animation:shimmer 2s infinite;animation:shimmer 2s infinite;content:""}@-webkit-keyframes shimmer{100%{-webkit-transform:translateX(100%);transform:translateX(100%)}}@-moz-keyframes shimmer{100%{-moz-transform:translateX(100%);transform:translateX(100%)}}@-o-keyframes shimmer{100%{-o-transform:translateX(100%);transform:translateX(100%)}}@keyframes shimmer{100%{-webkit-transform:translateX(100%);-moz-transform:translateX(100%);-o-transform:translateX(100%);transform:translateX(100%)}}'
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BSkeleton);


/***/ }),

/***/ 54865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36840);
/* harmony import */ var utils_slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27576);
/* harmony import */ var _useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74021);
/* harmony import */ var services_LinkService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41824);
/* harmony import */ var utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14211);





function useBreadcrumbs() {
    var locale = (0,_useLocale__WEBPACK_IMPORTED_MODULE_1__/* .useLocale */ .b)().locale;
    var baseBreadcrumbItem = {
        label: "Teknevia",
        link: "/",
        isTranslatable: false
    };
    var defaultBreadcrumbs = [
        baseBreadcrumbItem
    ];
    var generateCategoryLinks = function(category, location) {
        var generatedBreadcrumbsArray = [
            {
                label: category.label,
                link: (0,utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__/* .getLocalePrefix */ .A)(locale) + category.value,
                isTranslatable: false
            }, 
        ];
        if (location) {
            var _loop = function(idx) {
                var labelKey = labelKeys[idx];
                var slugKey = slugKeys[idx];
                var locationLabel = location[labelKey] + " " + category.label;
                var _slugKey;
                var locationSlug = services_LinkService__WEBPACK_IMPORTED_MODULE_2__/* .linkService.generateCategoryLink */ .k.generateCategoryLink({
                    locale: locale,
                    locationSlug: (_slugKey = location[slugKey]) !== null && _slugKey !== void 0 ? _slugKey : (0,utils_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugifyText */ .E)("".concat(locationLabel)),
                    category: category.value
                });
                var hasAnySameLabel = generatedBreadcrumbsArray.some(function(item) {
                    return item.label === locationLabel;
                });
                if (!hasAnySameLabel) {
                    generatedBreadcrumbsArray.push({
                        label: locationLabel,
                        link: locationSlug,
                        isTranslatable: false
                    });
                }
                if (labelKey.includes(matchType)) {
                    return "break";
                }
            };
            var labelKeys = [
                "cityName",
                "regionName",
                "harborName"
            ];
            var slugKeys = [
                "citySlug",
                "regionSlug",
                "harborSlug"
            ];
            var matchType = location.matchType;
            for(var idx in labelKeys){
                var _ret = _loop(idx);
                if (_ret === "break") break;
            }
        }
        return generatedBreadcrumbsArray;
    };
    var generateOrganizationBreadcrumbs = function(subPage) {
        return [
            baseBreadcrumbItem,
            {
                label: "organizations:home.title",
                link: "/hizmetler",
                isTranslatable: true
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(subPage ? [
            subPage
        ] : []));
    };
    return {
        defaultBreadcrumbs: defaultBreadcrumbs,
        onlyTekneViaBreadcrumb: defaultBreadcrumbs[0],
        generateCategoryLinks: generateCategoryLinks,
        generateOrganizationBreadcrumbs: generateOrganizationBreadcrumbs
    };
}


/***/ }),

/***/ 64978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hp": function() { return /* binding */ getPartnerTitleDescription; },
/* harmony export */   "vA": function() { return /* binding */ getVehicleHelmetSettings; }
/* harmony export */ });
/* unused harmony exports getSeoData, getTitleFromPageTitle, getMetadataForCustomPages, getMetadataForGuardedPages, getSearchMetadata */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21017);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59354);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36840);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50132);
/* harmony import */ var enums_locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42111);
/* harmony import */ var utils_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38602);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12313);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14211);








function getSeoData(asPath, locale, url) {
    return _getSeoData.apply(this, arguments);
}
function _getSeoData() {
    _getSeoData = _async_to_generator(function(asPath, locale, url) {
        var ref, pageData, seoData, content, helmetSettings, ref1, title, meta, _value, _data, page, _rendered;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getDataFromWordpress(asPath, locale)
                    ];
                case 1:
                    ref = _state.sent(), pageData = ref.pageData, seoData = ref.seoData;
                    content = null;
                    helmetSettings = {
                        title: "",
                        meta: [],
                        script: ""
                    };
                    if (seoData.status === "fulfilled") {
                        ref1 = generateMetaAndScriptFromRankMath(seoData.value.data, url), title = ref1.title, meta = ref1.meta;
                        helmetSettings.meta = meta;
                        helmetSettings.title = getTitleFromPageTitle(title);
                    }
                    if (pageData.status === "fulfilled") {
                        _value = pageData.value, _data = _sliced_to_array(_value.data, 1), page = _data[0];
                        if (!helmetSettings.title) {
                            helmetSettings.title = getTitleFromPageTitle(page === null || page === void 0 ? void 0 : page.title.rendered);
                        }
                        ;
                        content = (_rendered = page === null || page === void 0 ? void 0 : page.content.rendered) !== null && _rendered !== void 0 ? _rendered : null;
                    }
                    return [
                        2,
                        {
                            helmetSettings: helmetSettings,
                            content: content
                        }
                    ];
            }
        });
    });
    return _getSeoData.apply(this, arguments);
}
var getDataFromWordpress = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(asPath, locale) {
        var localePrefix, pageBlogUrl, seoPromise, pagePromise, ref, seoData, pageData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    localePrefix = locale === enums_locale__WEBPACK_IMPORTED_MODULE_0__/* .Locale.TR */ .g.TR ? "" : "/en";
                    pageBlogUrl = "".concat("https://www.teknevia.com/blog").concat(localePrefix).concat(asPath);
                    seoPromise = utils_axios__WEBPACK_IMPORTED_MODULE_1__/* .seoClient.get */ .qp.get("".concat((0,utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__/* .getLocalePrefix */ .A)(locale), "wp-json/rankmath/v1/getHead"), {
                        params: {
                            url: pageBlogUrl
                        }
                    });
                    pagePromise = utils_axios__WEBPACK_IMPORTED_MODULE_1__/* .seoClient.get */ .qp.get("".concat((0,utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__/* .getLocalePrefix */ .A)(locale), "wp-json/wp/v2/pages/?slug=").concat(asPath), {
                    });
                    return [
                        4,
                        Promise.allSettled([
                            seoPromise,
                            pagePromise
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), seoData = ref[0], pageData = ref[1];
                    return [
                        2,
                        {
                            seoData: seoData,
                            pageData: pageData
                        }
                    ];
            }
        });
    });
    return function getDataFromWordpress(asPath, locale) {
        return _ref.apply(this, arguments);
    };
}();
var getTitleFromPageTitle = function(pageTitle) {
    if (!pageTitle) {
        return "Teknevia | T\xfcrkiyenin en yenilik\xe7i yat & tekne kiralama platformu";
    }
    var titleStripped = pageTitle.replace(/<\/?[^>]+(>|$)/g, "").replace("- Teknevia", "| Teknevia");
    if (titleStripped.toLowerCase().includes("| teknevia")) {
        return he__WEBPACK_IMPORTED_MODULE_2___default().decode(titleStripped);
    }
    return he__WEBPACK_IMPORTED_MODULE_2___default().decode("".concat(titleStripped));
};
var getOgShareMetas = function(param) {
    var pageTitle = param.pageTitle, description = param.description, url = param.url, locale = param.locale, image = param.image, isNoIndex = param.isNoIndex;
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(!isNoIndex ? [
        {
            name: "robots",
            content: "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        }, 
    ] : []).concat([
        {
            property: "og:locale",
            content: locale
        },
        {
            property: "og:type",
            content: "article"
        },
        {
            property: "og:title",
            content: pageTitle
        },
        {
            property: "og:image",
            content: image !== null && image !== void 0 ? image : "https://cdn.teknevia.com/storefront/common/logo.png"
        }, 
    ], (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(description ? [
        {
            property: "og:description",
            content: description
        }, 
    ] : []), [
        {
            property: "og:url",
            content: url
        },
        {
            property: "og:site_name",
            content: "Teknevia"
        },
        {
            name: "twitter:card",
            content: "summary_large_image"
        },
        {
            name: "twitter:title",
            content: pageTitle
        }, 
    ], (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(description ? [
        {
            name: "twitter:description",
            content: description
        }, 
    ] : []), [
        {
            name: "twitter:image",
            content: image !== null && image !== void 0 ? image : "https://cdn.teknevia.com/storefront/common/logo.png"
        },
        {
            name: "twitter:site",
            content: "@TekneVia"
        },
        {
            name: "twitter:creator",
            content: "@TekneVia"
        }, 
    ]);
};
var replaceMetaImages = function(meta) {
    var metaCopy = _to_consumable_array(meta);
    if (metaCopy) {
        var ogImage = metaCopy.find(function(m) {
            return m.property === "og:image";
        });
        if (!ogImage) {
            metaCopy.push({
                property: "og:image",
                content: "https://cdn.teknevia.com/storefront/common/logo.png"
            });
            metaCopy.push({
                property: "twitter:image",
                content: "https://cdn.teknevia.com/storefront/common/logo.png"
            });
        }
    }
    return metaCopy;
};
var replaceSiteName = function(meta) {
    var metaCopy = _to_consumable_array(meta);
    var ogSiteNameIndex = metaCopy.findIndex(function(m) {
        return m.property === "og:site_name";
    });
    if (ogSiteNameIndex > -1) {
        metaCopy[ogSiteNameIndex].content = "Teknevia";
    }
    return metaCopy;
};
var generateMetaAndScriptFromRankMath = function(seoData, url) {
    var head = seoData.head;
    var meta = [];
    var title = "";
    var mainDomainHead = head.replaceAll("https://blog.teknevia.com", "https://www.teknevia.com");
    var splittedTags = mainDomainHead.split("\n").filter(function(h) {
        return !!h;
    });
    var attrRegexp = /(name|content|property)="([^"]*)"/g;
    splittedTags.forEach(function(tag) {
        if (tag.startsWith("<meta")) {
            var metaObj = {};
            var attrMatchedTags = _to_consumable_array(tag.matchAll(attrRegexp));
            attrMatchedTags.forEach(function(match, idx) {
                if (idx > 0 && attrMatchedTags[0][2] === "og:title") {
                    title = match[2];
                }
                if (checkRobotsNoFollowOrNoIndex(attrMatchedTags)) {
                    metaObj.name = "robots";
                    metaObj.content = "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large";
                    return;
                }
                metaObj[match[1]] = match[2];
                if (idx > 0 && attrMatchedTags[0][2].includes("url")) {
                    metaObj[match[1]] = "https://www.teknevia.com".concat(url);
                }
            });
            meta.push(metaObj);
        }
    });
    meta = replaceMetaImages(meta);
    meta = replaceSiteName(meta);
    return {
        meta: meta,
        title: title
    };
};
var checkRobotsNoFollowOrNoIndex = function(attrMatchedTags) {
    var tag = attrMatchedTags[0][2];
    var content = attrMatchedTags[1][2];
    return tag === "robots" && content.includes("nofollow") || content.includes("noindex");
};
var getMetadataForCustomPages = function(title, url, locale, description) {
    var pageTitle = getTitleFromPageTitle(title);
    var metadata = {
        title: pageTitle
    };
    metadata.meta = _to_consumable_array(getOgShareMetas({
        pageTitle: pageTitle,
        url: url,
        locale: locale
    }));
    if (description) {
        var summaryDescription = description.length > 160 ? description.substring(0, 160).split(/ |\n/).slice(0, -1).join(" ") + "..." : description;
        metadata.meta.push({
            name: "description",
            content: he.decode(summaryDescription)
        });
    }
    return metadata;
};
var getMetadataForGuardedPages = function(title, url, locale) {
    var metadata = getMetadataForCustomPages(title, url, locale);
    if (!metadata.meta) {
        metadata.meta = [];
    }
    metadata.meta.push({
        name: "robots",
        content: "noindex"
    });
    metadata.meta.push({
        name: "googlebot",
        content: "noindex"
    });
    return metadata;
};
var getSearchMetadata = function(locale, url, title, description) {
    var metadataMap = {
        tr: {
            title: title,
            meta: [
                {
                    name: "description",
                    content: description
                }, 
            ]
        },
        en: {
            title: title,
            meta: [
                {
                    name: "description",
                    content: description
                }, 
            ]
        }
    };
    var metadata = metadataMap[locale];
    metadata.meta = _to_consumable_array(metadata.meta).concat(_to_consumable_array(getOgShareMetas({
        pageTitle: metadata.title,
        url: url,
        locale: locale,
        description: metadata.meta[0].content
    })));
    return metadata;
};
var getVehicleScriptSchema = function(param) {
    var description = param.description, rating = param.rating, commentCount = param.commentCount, ratingCount = param.ratingCount, images = param.images, name = param.name, url = param.url, category = param.category;
    // -category (Kiralık Tekneler vs gibi kw kullanımlı)
    var aggregateRating = ',"aggregateRating": {"@type": "AggregateRating","ratingValue": "'.concat(rating || 4, '","reviewCount": "').concat(commentCount || 1, '","ratingCount": "').concat(ratingCount || 1, '"}');
    return '{"@context": "https://www.schema.org","@type": "Product","url": "'.concat(url, '","name": "').concat(name, '","description": "').concat(description, '","image": [').concat(images.map(function(i) {
        return '"'.concat(i, '"');
    }).join(","), '],"category": "').concat(category, '"').concat(aggregateRating, "}");
};
var getVehicleHelmetSettings = function(title, description, locale, url, vehicleImage, vehicleProductSchemaData) {
    var pageTitle = getTitleFromPageTitle(title);
    return {
        title: pageTitle,
        meta: [
            {
                name: "description",
                content: description
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(getOgShareMetas({
            pageTitle: pageTitle,
            description: description,
            image: vehicleImage,
            url: url,
            locale: locale
        }))),
        script: getVehicleScriptSchema(vehicleProductSchemaData)
    };
};
var getPartnerTitleDescription = function(description, locale) {
    var title = locale === enums_locale__WEBPACK_IMPORTED_MODULE_0__/* .Locale.TR */ .g.TR ? "Teknevia'nın Partneri Olun!" : "Become Teknevia's Partner!";
    var pageTitle = "".concat(title);
    var url = locale === enums_locale__WEBPACK_IMPORTED_MODULE_0__/* .Locale.TR */ .g.TR ? "partner" : "/en/partner";
    return {
        title: pageTitle,
        meta: [
            {
                name: "description",
                content: description
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(getOgShareMetas({
            locale: locale,
            pageTitle: pageTitle,
            url: url,
            description: description,
            image: "https://cdn.teknevia.com/storefront/partner/partner.png"
        })))
    };
};


/***/ }),

/***/ 94553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useVehicleDetailCommentsModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18098);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15578);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52500);




var useVehicleDetailCommentsModal = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .devtools */ .mW)(function(set) {
    return {
        isCommentModalVisible: false,
        setCommentModalVisible: function(val) {
            return set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                    isCommentModalVisible: val
                });
            });
        }
    };
}));


/***/ })

}]);